import { useEffect, useState } from "react";
import { PAGEPTOPICON } from "../Utils/icons";
export default function GoToTop() {
  const clickHandler = () => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };
  const [isVisible, setIsVisible] = useState(false);
  const listenToScroll = () => {
    const hightToHidden = 312;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > hightToHidden) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
  }, []);
  return (
    <div className="top-btn-wrapper">
      {isVisible && (
        <div className="top-btn" onClick={clickHandler}>
          <PAGEPTOPICON className="top-btn-icon" />
        </div>
      )}
    </div>
  );
}
